import { SIDE_BAR_NAVS, BROKER_SIDE_BAR_NAVS } from '../../../resources/constants';
import useUserAccount from '../../../hooks/userAccountHook';
import NavigationSection from './NavigationSection';

interface NavigationProps {
  isSidebarExpanded: boolean;
  onMenuClick: () => void;
  expandedCategories: Record<string, boolean>;
  toggleCategory: (category: string) => void;
  expandedNavItems: Set<string>;
  toggleNavItem: (path: string) => void;
  handleToggleFullNav?: () => void;
}

export default function Navigation({
  isSidebarExpanded,
  onMenuClick,
  expandedCategories,
  toggleCategory,
  expandedNavItems,
  toggleNavItem,
  handleToggleFullNav
}: NavigationProps) {
  const { user } = useUserAccount();

  if (user.isBroker()) {
    // For brokers: Render main items directly without section headers
    return (
      <div className='flex bg-white dark:bg-darkBg flex-col h-full overflow-y-auto py-2'>
        <div className=''>
          <NavigationSection
            categoryKey='main'
            title=''
            navItems={BROKER_SIDE_BAR_NAVS?.main || []}
            hideSectionHeader={true}
            isSidebarExpanded={isSidebarExpanded}
            onMenuClick={onMenuClick}
            expandedCategories={expandedCategories}
            toggleCategory={toggleCategory}
            expandedNavItems={expandedNavItems}
            toggleNavItem={toggleNavItem}
            handleToggleFullNav={handleToggleFullNav}
          />
        </div>
      </div>
    );
  }

  // For other users: Render with section headers
  return (
    <div className='flex bg-white dark:bg-darkBg flex-col h-full overflow-y-auto py-2'>
      <div className=''>
        <NavigationSection
          categoryKey='main'
          title='Dashboard'
          navItems={SIDE_BAR_NAVS?.main || []}
          isSidebarExpanded={isSidebarExpanded}
          onMenuClick={onMenuClick}
          expandedCategories={expandedCategories}
          toggleCategory={toggleCategory}
          expandedNavItems={expandedNavItems}
          toggleNavItem={toggleNavItem}
        />
        <NavigationSection
          categoryKey='manage'
          title='Manage'
          navItems={SIDE_BAR_NAVS?.manage || []}
          isSidebarExpanded={isSidebarExpanded}
          onMenuClick={onMenuClick}
          expandedCategories={expandedCategories}
          toggleCategory={toggleCategory}
          expandedNavItems={expandedNavItems}
          toggleNavItem={toggleNavItem}
        />
        <NavigationSection
          categoryKey='financials'
          title='Financials'
          navItems={SIDE_BAR_NAVS?.financials || []}
          isSidebarExpanded={isSidebarExpanded}
          onMenuClick={onMenuClick}
          expandedCategories={expandedCategories}
          toggleCategory={toggleCategory}
          expandedNavItems={expandedNavItems}
          toggleNavItem={toggleNavItem}
        />
        <NavigationSection
          categoryKey='system'
          title='System'
          navItems={SIDE_BAR_NAVS?.system || []}
          isSidebarExpanded={isSidebarExpanded}
          onMenuClick={onMenuClick}
          expandedCategories={expandedCategories}
          toggleCategory={toggleCategory}
          expandedNavItems={expandedNavItems}
          toggleNavItem={toggleNavItem}
        />
      </div>
    </div>
  );
}
